/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-cycle */
import ReactGA from 'react-ga';

import Util from './Util';

export default class Analytics {
    static initialize(gaTrackingId, debug = false) {
        if (gaTrackingId && gaTrackingId !== '') {
            const options = {debug, titleCase: false};

            ReactGA.initialize(gaTrackingId, options);
            this._ReactGA = ReactGA;
        } else if (process.env.NODE_ENV !== 'test') {
            console.warn('React GA requires a tracking ID.'); // eslint-disable-line
        }
    }

    static trackEvent(category, action, integerValue, label) {
        const debugLogs = !this._ReactGA;

        if (this._ReactGA || debugLogs) {
            if (category && action) {
                const event = {
                    category: `ML3${Util.isWidget() ? ' (Widget)' : ''} : ${category}`,
                    action
                };

                if (integerValue !== undefined) {
                    if (!Number.isInteger(integerValue)) {
                        console.warn('GA.trackEvent value parameter *must* be an integer!'); // eslint-disable-line
                    }
                    event.value = integerValue;
                }

                if (label) {
                    event.label = label;
                }

                if (this._ReactGA) {
                    this._ReactGA.event(event);
                }
                if (debugLogs) {
                    this.debugLogEvent(event);
                }
            } else if (process.env.NODE_ENV !== 'test') {
                console.warn('Tracking event requires at least a category and action.'); // eslint-disable-line
            }
        } else if (process.env.NODE_ENV !== 'test') {
            console.warn('React GA has not been initialized.'); // eslint-disable-line
        }
    }

    static debugLogEvent(event) {
        const keys = Object.keys(event);
        let eventStr = 'GA DEBUG: {hitType: "event", ';
        keys.forEach((prop, idx) => {
            const key = `event${Util.capitalize(prop)}`;
            const val = prop === 'value' ? event[prop] : `"${event[prop]}"`;
            eventStr += `${key}: ${val}${idx < keys.length - 1 ? ', ' : '}'}`;
        });
        if (process.env.NODE_ENV !== 'test') {
            console.log(eventStr); //eslint-disable-line
        }
        return eventStr;
    }
}
